<template>
  <div class="Personal">
    <ul class="titleList">
      <li class="title">我的管理</li>
      <!-- <li
        :class="{ selected: curPath === '/mall/personal/cart' }"
        @click="navTo('/mall/personal/cart')"
      >
        购物车
      </li> -->

      <li
        :class="{ selected: curPath === '/mall/personal/myAddress' }"
        @click="navTo('/mall/personal/myAddress')"
      >
        收货地址
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/changePwd' }"
        @click="navTo('/mall/personal/changePwd')"
      >
        修改密码
      </li>
      <li class="title">订单中心</li>
      <li
        :class="{ selected: curPath === '/mall/personal/myOrder' }"
        @click="navTo('/mall/personal/myOrder')"
      >
        我的订单
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/Shelves' }"
        @click="navTo('/mall/personal/Shelves')"
      >
        上架审核
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/Purchase' }"
        @click="navTo('/mall/personal/Purchase')"
      >
        采购审核
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/returnGoods' }"
        @click="navTo('/mall/personal/returnGoods')"
      >
        退货申请
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/barter' }"
        @click="navTo('/mall/personal/barter')"
      >
        换货申请
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/repair' }"
        @click="navTo('/mall/personal/repair')"
      >
        维修申请
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/extraStandard' }"
        @click="navTo('/mall/personal/extraStandard')"
      >
        标外维修
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/commodityApplication' }"
        @click="navTo('/mall/personal/commodityApplication')"
      >
        标外商品申请
      </li>

      <!-- <li
        :class="{ selected: curPath === '/mall/personal/myData' }"
        @click="navTo('/mall/personal/myData')"
      >
        修改资料
      </li> -->
      <li class="title">更多</li>
      <li
        :class="{ selected: curPath === '/mall/personal/satisfaction' }"
        @click="navTo('/mall/personal/satisfaction')"
      >
        满意度评测
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/wechat' }"
        @click="navTo('/mall/personal/wechat')"
      >
        微信客服
      </li>
    </ul>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Personal",
  computed: {
    ...mapState(["clientToken", "clientName"]),
    form_head_uuid () {
      return this.$store.state.form_head_uuid
    }
  },
  data () {
    return {
      curPath: this.$route.path,
    };
  },

  methods: {
    navTo (route) {
      this.$router.push(route);
    },
  },

  mounted () { },

  watch: {
    $route (to, from) {
      this.curPath = to.path;
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.Personal {
  padding-top: 20px;
  height: 100%;
  display: flex;
  align-content: flex-start;
  .titleList {
    width: 180px;
    height: 100%;
    background: #fff;
    padding: 20px 36px;
    overflow: hidden;
    min-height: 1084px;
    li {
      width: 100%;
      // margin: 20px 0;
      padding: 20px 0;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      border-left: 2px solid transparent;
    }
    .selected {
      // border-left: 2px solid @thirdColor;
      // color: ;
      color: @thirdColor;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      border-bottom: 1px solid #eaeaea;
    }
  }
  .content {
    flex: 1;
    margin-left: 20px;
    overflow: hidden;
    display: inline-block;
    vertical-align: top;
    background: #fff;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/Personal.vue